import { AfterContentInit, Component, Inject, Input, OnChanges, OnDestroy, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IAppConfig } from '../../../core/config/app-config.model';
import { APP_CONFIG } from '../../../core/config/app-config.service';
import intlTelInput from 'intl-tel-input'
import { Subscription, interval } from 'rxjs';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputPhoneComponent),
  multi: true
};

interface CountryCode { 
  name: string, 
  iso2: string, 
  dialCode: string 
}

const AUSTRALIA_CODE = 'au'
const AU_PHONE_PREFIX_ALLOW = ['1800', '1300'];

@Component({
  selector: 'app-input-phone',
  standalone: false,
  templateUrl: './input-phone.component.html',
  styleUrls: ['./input-phone.component.sass'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class InputPhoneComponent implements OnInit, ControlValueAccessor, OnDestroy {

  constructor(
    @Inject(APP_CONFIG) protected config: IAppConfig,
  ) { }

  initInput: any = undefined;
  inputForm: any = undefined;
  @Input('name') name?: string;
  @Input('readonly') readonly?: boolean;
  @Input() disabled: boolean = false;

  initUniqueId: number = Number(new Date().getTime());


  ngOnInit(): void {
    this.initInputForm();
  }

  ngOnDestroy(): void {
    this.initInput?.destroy();
  }

  initInputForm(done?: Function) {
    this.inputForm = document.querySelector(`#inputPhone-${this.name}-${this.initUniqueId}`);
    if (this.inputForm) {
      this.initInput = intlTelInput(this.inputForm, {
        // utilsScript: "assets/js/phoneInputUtils.js",
        loadUtils: () => import("intl-tel-input/utils" as any),
        allowDropdown: true,
        // showSelectedDialCode: true,
        formatAsYouType: true,
        // autoInsertDialCode: false,
        formatOnDisplay: true,
        nationalMode: false,
        separateDialCode: true,
        customPlaceholder: function(selectedCountryPlaceholder: string, selectedCountryData: any) {
          return '';
        },
      });
      this.initInput?.setCountry(AUSTRALIA_CODE);
      this.inputForm.addEventListener('input', () => this._valueChange())
      this.inputForm.addEventListener("countrychange", () => this._valueChange());
      setTimeout(() => {
        done && done();
      }, 100);
    }
  }

  getIDInput() {
    return this.name ? `inputPhone-${this.name}-${this.initUniqueId}` : ''
  }


  get value(): string {
    const a = this.initInput?.getNumber() || '';
    return a;
  }

  saveValue: string = '';
  subscription?: Subscription;
  isLoading: boolean = false;

  writeValue(data: string) {
    data =  this.checkPhoneExtDuplicate(data);
    const setData = () => {
      if ((data || data === '') && this.initInput && data !== this.initInput.getNumber()) {
        this.initInput.setNumber(data);
        this.subscription = interval(200).subscribe(() => {
          let val = this.initInput?.getNumber();
          if(val == data){
            this.saveValue = data;
            this._valueChange();
            this.subscription?.unsubscribe();
          }
        });
      }
    }

    if (!this.initInput) {
      this.initInputForm(() => setData());
      return;
    }

    setData();
  }
 
  checkPhoneExtDuplicate(data: string) {
    let formatData = '';
    if(data && ((data.match(/\+/g) || []).length >= 1)) {
      data = data.replace(/[()\s]/g, '');
      formatData = data.substring(data.lastIndexOf('+')); 
      return formatData;
    } else if (data && !data.includes('+')) {
      formatData = '+' + data;
    } else {
      formatData = data;
    }
    return formatData;
  }

  private _valueChange() {
    if (!this.initInput) {
      this.initInputForm(() => this.validatePhone());
      return
    }

    setTimeout(() => {
      this.validatePhone();
    }, 100)
  }

  checkPhoneInAustralia(phone: string) {
    // 10 digits and start with 1800, 1300
    const isTenDigits = /^\d{10}$/.test(phone);
    const hasAllowedPrefix = AU_PHONE_PREFIX_ALLOW.some(prefix => phone.startsWith(prefix));
    return isTenDigits && hasAllowedPrefix;
  }

  validatePhone(){
    let phone: string = this.initInput?.getNumber();
    let input: string = this.inputForm.value;
    let countryCode: CountryCode = this.initInput?.getSelectedCountryData();
    let isValid: boolean = true;
    const ext = this.getExtension();

    if (phone && !this.initInput.isValidNumber()) {
      const isAustralian = countryCode?.iso2.toLowerCase() === AUSTRALIA_CODE;
      const isValidAustralianPhone = isAustralian && this.checkPhoneInAustralia(phone.replace(`+${ext.dialCode}`, ''));
    
      if (!isValidAustralianPhone) {
        phone = 'error-number';
        isValid = false;
      }
    }
    if (input && this.includeAlphabet(input)) {
      phone = 'error-number';
      isValid = false;
    }

    if(phone){
      this.isLoading = true;
    }

    if(!this.isLoading){
      this.isLoading = true;
      return;
    }

    phone = phone.replace(`+${ext.dialCode}`, `(+${ext.dialCode})`);
    this.propagateChange(phone);
    setTimeout(() => {
      this.propagateChange(phone);
    }, 100)
  }

  getExtension() {
    return this.initInput?.getSelectedCountryData();
  }

  includeAlphabet(number: string): boolean {
    return /[a-zA-Z]/g.test(number);
  }

  propagateChange = (_: any) => {

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {

  }



}
